import LogRocket from 'logrocket';

type InitOptions = Parameters<typeof LogRocket.init>[1];
type IdentifyTraits = Record<string, string | number | boolean>;

const init = (appId: string, options?: InitOptions): void => {
  LogRocket.init(appId, options);
};

const identify = (uid: string, traits?: IdentifyTraits): void => {
  LogRocket.identify(uid, traits);
};

export { init, identify };
